// @ts-check
import { findIndex } from 'ramda'

import { UsersController } from '../settings/users/viewUsers.ctrl'
import usersTemplate from '../settings/users/viewUsersModal.html'
import { EditCompanyController } from './edit/ctrl'
import editCompanyTemplate from './edit/tpl.html'
import { CLIENTS_USER_GROUP } from '../../constants'

class CompaniesData {
  /* @ngInject */
  constructor ($mdDialog, $mdToast, $scope, companies, Companies, $rootScope, user, $window, regions, $interval) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.Companies = Companies
    this.$window = $window
    $interval(function () {}, 1000)
    this.$rootScope = $rootScope
    this.$scope = $scope
    this.users
    this.regions = regions
    this.selectedCompanyId
    this.admins
    this.user = user
    this.companyData
    this.companyCCIDsData
    this.addUserEmail
    this.switchCompanyId
    this.sortReverse = false
    this.companiesList = companies.companies
  }

  selectUsersPrompt (company) {
    this.$rootScope.$broadcast('app:loading:start')
    this.selectedCompanyId = company.company_id

    this.users = null

    this.Companies.adminFetchCompany(company.company_id)
      .then(this.setCompanyData.bind(this))
      .then(() => this.Companies.fetchCompanyUsers(company.company_external_id, CLIENTS_USER_GROUP))
      .then(this.getCompanyUsers.bind(this))
      .then(this.viewUsers.bind(this))
      .then(this.stopLoader.bind(this))
      .catch(this.companyUsersErr.bind(this))
  }

  companyUsersErr (e) {
    if (!e) return
    this.stopLoader()
    this.$mdToast.showSimple('Unable to fetch company users')
  }

  getCompanyData (companyId) {
    this.Companies.adminFetchCompany(companyId)
      .then(this.setCompanyData.bind(this))
      .then(() => this.Companies.getCompanyCCIDsMappings(companyId))
      .then(this.setCompanyCCIDsData.bind(this))
      .then(this.Companies.fetchAdmins.bind(this))
      .then(this.editCompany.bind(this))
  }

  setCompanyData (results) {
    this.companyData = results
  }

  setCompanyCCIDsData (results) {
    this.companyCCIDsData = results.data.allMappings
  }

  editCompany (adminData) {
    const parentEl = document.body
    this.admins = adminData
    return this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      template: editCompanyTemplate,
      clickOutsideToClose: true,
      locals: {
        $window: this.$window,
        user: this.user,
        admins: this.admins,
        companyInfo: this.companyData,
        companyCCIDsData: this.companyCCIDsData,
        regions: this.regions,
        companiesList: this.companiesList
      },
      controller: EditCompanyController,
      controllerAs: 'new'
    })
    .then(updatedCompany => {
      const index = findIndex(company => company.id === updatedCompany.internal_id, this.companiesList)
      for (let prop in this.companiesList[index]) {
        if (this.companiesList[index].hasOwnProperty(prop) && typeof updatedCompany[prop] !== 'undefined') {
          this.companiesList[index][prop] = updatedCompany[prop]
        }
      }
    }, () => {})
  }

  getCompanyUsers (usersData) {
    this.users = usersData
  }

  addUserToCompany () {
    this.Companies.addUserToCompany({
      companyId: this.switchCompanyId,
      username: this.addUserEmail
    })
      .then(() => {
        this.$mdToast.showSimple('Change Company Success')
        this.newUserCreate = false
        this.$mdDialog.hide()
      })
      .catch((err) => {
        if (!err) return
        this.$mdToast.showSimple(`Error Sending Account: ${err.data.reason}`)
      })
  }

  viewUsers () {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: usersTemplate,
      clickOutsideToClose: true,
      locals: {
        users: this.users,
        company: this.companyData,
        user: this.user,
        regions: this.regions
      },
      fullscreen: true,
      controller: UsersController,
      controllerAs: 'u'
    })
  }

  stopLoader () {
    this.$rootScope.$broadcast('app:loading:done')
  }
}

export default CompaniesData
